import type { ProjectType } from '../../../../../services/projectTypeService';
import { SOVEREIGN } from '../../../utils/epcProjectVisual';
import { THEME_STYLES, themeFromCategory } from '../ui';

export default function ProjectTypeCards({
  types,
  value,
  onChange,
  loading,
}: {
  types: ProjectType[];
  value: string;
  onChange: (id: string) => void;
  loading: boolean;
}) {
  if (loading) {
    return (
      <div className="flex flex-wrap gap-2">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className="h-[74px] w-32 animate-pulse rounded-xl" style={{ background: 'rgba(11,59,46,0.08)' }} />
        ))}
      </div>
    );
  }
  return (
    <div role="radiogroup" aria-label="Project type" className="flex flex-wrap gap-2">
      {types.map((t) => {
        const id = t._id || t.id || '';
        const theme = THEME_STYLES[themeFromCategory(t.category)];
        const Icon = theme.icon;
        const selected = id === value;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(id)}
            className="group flex min-w-[8rem] flex-col items-start gap-1.5 rounded-xl px-3.5 py-3 text-left transition"
            style={
              selected
                ? {
                    background: 'rgba(201,169,97,0.14)',
                    border: '1px solid rgba(11,59,46,0.55)',
                    boxShadow: '0 0 0 2px rgba(201,169,97,0.35), 0 8px 18px -14px rgba(11,59,46,0.5)',
                  }
                : { background: SOVEREIGN.inputBg, border: `1px solid ${SOVEREIGN.inputBorder}` }
            }
          >
            <span
              className="flex h-7 w-7 items-center justify-center rounded-lg text-white"
              style={{ background: selected ? theme.accent : `${theme.accent}B3` }}
            >
              <Icon className="h-3.5 w-3.5" strokeWidth={2.2} />
            </span>
            <span className="text-[13px] font-bold leading-tight" style={{ color: selected ? SOVEREIGN.title : SOVEREIGN.ink }}>
              {t.name}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-[0.12em]" style={{ color: theme.accent }}>
              {theme.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
